import * as React from "react";
import PropTypes from "prop-types";
import SplashView from "./SplashView";
import SignedInView from "./SignedInView";
import SignedOutView from "./SignedOutView";
import useAuth from "./useAuth";
import { MessageBar, MessageBarType } from "@fluentui/react";
import { useMessageBar } from "./useMessageBar";

export default function App({ isOfficeInitialized }) {
  if (isOfficeInitialized) {
    return <InitializedApp />;
  }
  return <SplashView text="Initializing..." />;
}

function InitializedApp() {
  const [message, setMessage] = useMessageBar();
  const [signingIn, signingOut, auth, onSignIn, onSignOut, error] = useAuth(setMessage);
  let content;

  if (signingIn) {
    content = <SplashView text="Signing in..." />;
  } else if (signingOut) {
    content = <SplashView text="Signing out..." />;
  } else if (auth) {
    content = <SignedInView auth={auth} setMessage={setMessage} onSignOut={() => onSignOut()} signOutError={error} />;
  } else {
    content = <SignedOutView onSignIn={() => onSignIn()} signInError={error} />;
  }
   
  return (
    <div className="app__container">
      { message && <MessageBar messageBarType={message.type} onDismiss={() => setMessage(null)}>{message.text}</MessageBar> }
      <div className="app__container_content">
        {content}
      </div>
    </div>
  );
}

App.propTypes = {
  title: PropTypes.string,
  isOfficeInitialized: PropTypes.bool,
};
